<template>
  <div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <div
        v-for="(item, index) in broadcastInfo"
        :key="index"
        class="rounded-md p-1 border border-[#828282]"
      >
        <div>
          {{ defineBroadcastTypeCard(item.broadcast_type) }}
        </div>
        <div class="text-semibold mt-2 text-xl text-[#626262]">
          {{ item.broadcast_total_message || 0 }}
        </div>
      </div>
    </div>
    <div class="flex mt-3 gap-4 md:gap-0 justify-between">
      <div class="flex gap-2">
        <div>
          <BInputGroup class="input-group-merge">
            <BInputGroupPrepend is-text>
              <b-img
                fluid
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/search-normal-1.svg"
                alt="search"
              />
            </BInputGroupPrepend>
            <BFormInput
              v-model="broadcast.search"
              size="md"
              placeholder="Cari berdasarkan judul"
              style="padding: 8px 1rem"
              @input="handleSearchReceiver"
            />
          </BInputGroup>
        </div>
        <b-dropdown
          id="dropdown-1"
          class="filter"
          no-caret
          variant="primary"
          toggle-class="text-decoration-none toggle-custom rounded-lg !py-[5px] !px-[10px]"
          no-close-on-click
        >
          <template #button-content>
            <b-img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
              height="24"
            />
          </template>

          <b-dropdown
            id="dropdown-2"
            class="w-100"
            toggle-class="text-left"
            variant="none"
            left
            no-caret
            dropright
            menu-class="overflow-y-auto "
          >
            <template #button-content>
              <div class="flex w-100 justify-between">
                <span class="hover-salmon text-6 ">Tipe Pesan</span>
                <b-icon
                  icon="chevron-right"
                  class="cursor-pointer"
                />
              </div>
            </template>
            <b-dropdown-form
              v-for="(option, index) in typeMessage"
              :key="index"
              class="w-[180px]"
            >
              <b-form-checkbox
                v-model="broadcast.broadcast_type"
                :name="`checkbox-${index}`"
                :value="option.value"
                class="text-6"
                @change="handleFilter()"
              >
                {{ option.label }}
              </b-form-checkbox>
            </b-dropdown-form>
          </b-dropdown>
          <b-dropdown
            id="dropdown-3"
            class="w-100"
            toggle-class="text-left"
            variant="none"
            left
            no-caret
            dropright
            menu-class="overflow-y-auto "
          >
            <template #button-content>
              <div class="flex w-100 justify-between">
                <span class="hover-salmon text-6 ">Status Pesan</span>
                <b-icon
                  icon="chevron-right"
                  class="cursor-pointer"
                />
              </div>
            </template>
            <b-dropdown-form
              v-for="(option, index) in status"
              :key="index"
              style="width: 180px"
            >
              <b-form-checkbox
                v-model="broadcast.broadcast_status"
                :name="`checkbox-${index}`"
                class="text-6 "
                :value="option.value"
                @change="handleFilter()"
              >
                {{ option.label }}
              </b-form-checkbox>
            </b-dropdown-form>
          </b-dropdown>
        </b-dropdown>
      </div>
      <div>
        <DateRangePicker
          ref="picker"
          v-model="filter.dateRange"
          :locale-data="locale"
          :opens="'left'"
          :ranges="ranges"
          :max-date="new Date()"
          class="w-100"
        >
          <template
            v-slot:input="picker"
            class="min-w-[350px]"
          >
            <div class="d-flex justify-content-between align-items-center w-100">
              <div class="mr-1">
                <span
                  style="color: #828282 !important"
                > {{ DAY_MONTH_YEAR(picker.startDate) }} - {{ DAY_MONTH_YEAR(picker.endDate) }}</span>
              </div>
              <div class="padding-arrow border-l">
                <b-img
                  class="pl-[7px]"
                  src="https://storage.googleapis.com/komerce/assets/icons/date-picker-icon.svg"
                />
              </div>
            </div>
          </template>
        </DateRangePicker>
      </div>
    </div>
    <b-row class="">
      <b-col>
        <BOverlay
          :show="broadcast.loading"
          spinner-variant="primary"
          variant="light"
          blur="0"
          opacity=".5"
          rounded="sm"
        >
          <BTable
            id="scroll"
            ref="scroll"
            :items="items"
            :fields="fieldsBroadcastTable"
            show-empty
            empty-text="Tidak ada data yang ditampilkan."
            responsive
            sticky-header="500px"
            class="mt-1"
            @scroll.native="handleScroll"
          >
            <template #cell(tittle)="data">
              <div class="grid">
                <div><span class="text-black">{{ data.item.title }}</span></div>
                <span class="text-[#7A8489]">{{ data.item.schedule }}</span>
              </div>
            </template>
            <template #cell(broadcast_type)="data">
              <span class="text-black">{{ defineBroadcastType(data.item.broadcast_type) }}</span>
            </template>
            <template #cell(contact_total)="data">
              <span class="text-black">{{ data.item.total }}</span>
            </template>
            <template #cell(succes)="data">
              <span class="text-[#34A770]">{{ data.item.success }}</span>
            </template>
            <template #cell(failed)="data">
              <span class="text-[#E31A1A]">{{ data.item.failed }}</span>
            </template>
            <template #cell(status)="data">
              <div>
                <div
                  v-show="data.item.status === 'PAUSED' || data.item.status === 'READY' "
                  class="bg-[#FFEDED]  rounded-lg py-[4px]"
                >
                  <div class="text-center text-[#E31A1A] font-[500]">
                    Terjeda <b-icon
                      v-if="data.item.status === 'READY'"
                      :id="`info-${data.item.id}-${data.index}`"
                      icon="info-circle"
                      class="cursor-pointer"
                    />
                    <b-popover
                      :target="`info-${data.item.id}-${data.index}`"
                      placement="top"
                      triggers="hover focus"
                    >
                      <div>
                        <div class="font-medium text-black">
                          Pengiriman Terjadwal
                        </div>
                        <div>
                          Dikirim pada : {{ DDMMYYYY(data.item.schedule) }}
                        </div>
                        <div>
                          Waktu : {{ TIME(data.item.schedule) }}
                        </div>
                      </div>
                    </b-popover>
                  </div>
                </div>
                <div
                  v-show="data.item.status === 'FAILED'"
                  class="bg-[#FFEDED]  rounded-lg py-[4px]"
                >
                  <div class="text-center text-[#E31A1A] font-[500]">
                    Tidak Terkirim
                  </div>
                </div>
                <div
                  v-show="data.item.status === 'SUCCESS'"
                  class="bg-[#DCF3EB]  rounded-lg py-[4px]"
                >
                  <div class="text-center text-[#34A770] font-[500]">
                    Selesai
                  </div>
                </div>
                <div
                  v-show="data.item.status === 'PROCESSING'"
                  class="bg-[#FFF2E2] rounded-lg py-[4px]"
                >
                  <div class="text-center text-[#FBA63C] font-[500]">
                    Mengirim
                  </div>
                </div>
                <div
                  v-show="data.item.status === 'CANCELLED'"
                  class="bg-[#E2E2E2] rounded-lg py-[4px]"
                >
                  <div class="text-center text-[#828282] font-[500]">
                    Dibatalkan
                  </div>
                </div>
              </div>
            </template>
            <template #cell(action)="data">
              <div v-if="data.item.status !== 'SUCCESS' && data.item.status !== 'FAILED'">
                <div
                  v-if="data.item.status === 'PAUSED' "
                  class="flex gap-2"
                >
                  <div
                    role="button"
                    aria-readonly="true"
                    :disabled="data.item.status === 'READY'"
                    class="border items-center cursor-pointer gap-2 flex border-1 justify-center w-[128px] border-[#E2E2E2] py-[3px] px-[0.6rem] rounded-lg"
                    @click="handleActionBroadcast(data.item.id,'resume')"
                  >
                    <img
                      src="https://storage.googleapis.com/komerce/assets/icons/play.svg"
                      alt="icon-play"
                      srcset=""
                    >
                    <div>Lanjutkan</div>
                  </div>
                  <div>
                    <div

                      class="border items-center cursor-pointer gap-2 flex border-1 justify-center w-[128px] border-[#E2E2E2] py-[3px] px-[0.6rem] rounded-lg"
                      @click="handleActionBroadcast(data.item.id,'cancel')"
                    >
                      <img
                        class="w-1/6 rotate-180"
                        src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/send-2.svg"
                        alt="icon pause"
                        srcset=""
                      >
                      <div>Batalkan</div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="data.item.status === 'SUCCESS' || data.item.status === 'FAILED'"
                  class="border items-center cursor-pointer gap-2 justify-center flex border-1 w-[128px] border-[#E2E2E2] py-[3px] px-[0.6rem] rounded-lg"
                  @click="handleActionBroadcast(data.item.id,'resend')"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/icons/send-2.svg"
                    alt="icon-send"
                    srcset=""
                  >
                  <div>Kirim Ulang</div>
                </div>
                <div
                  v-if="data.item.status === 'PROCESSING'"
                  class="flex gap-2"
                >
                  <div

                    class="border items-center cursor-pointer gap-2 flex border-1 justify-center w-[128px] border-[#E2E2E2] py-[3px] px-[0.6rem] rounded-lg"
                    @click="handleActionBroadcast(data.item.id,'pause')"
                  >
                    <img
                      class="w-1/6"
                      src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/pause.svg"
                      alt="icon pause"
                      srcset=""
                    >
                    <div>Jeda</div>
                  </div>
                  <div>
                    <div

                      class="border items-center cursor-pointer gap-2 flex border-1 justify-center w-[128px] border-[#E2E2E2] py-[3px] px-[0.6rem] rounded-lg"
                      @click="handleActionBroadcast(data.item.id,'cancel')"
                    >
                      <img
                        class="w-1/6 rotate-180"
                        src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/send-2.svg"
                        alt="icon pause"
                        srcset=""
                      >
                      <div>Batalkan</div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="data.item.status === 'CANCELLED'"
                  class="border items-center cursor-pointer gap-2 flex border-1 justify-center w-[128px] border-[#E2E2E2] py-[3px] px-[0.6rem] rounded-lg"
                  @click="handleActionBroadcast(data.item.id,'delete')"
                >
                  <img
                    class="w-1/6"
                    src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/trash.svg"
                    alt="icon pause"
                    srcset=""
                  >
                  <div>Hapus</div>
                </div>
                <div v-if="data.item.status === 'READY'">
                  <div

                    class="border items-center cursor-pointer gap-2 flex border-1 justify-center w-[128px] border-[#E2E2E2] py-[3px] px-[0.6rem] rounded-lg"
                    @click="handleActionBroadcast(data.item.id,'cancel')"
                  >
                    <img
                      class="w-1/6 rotate-180"
                      src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/send-2.svg"
                      alt="icon pause"
                      srcset=""
                    >
                    <div>Batalkan</div>
                  </div>
                </div>
              </div>
              <div v-else>
                <b-dropdown
                  id="dropdown-1"
                  squared
                  class="filter"
                  no-caret
                  variant="outline-secondary"
                  toggle-class="text-decoration-none toggle-custom rounded-lg !py-[5px] !px-[10px]"
                  no-close-on-click
                >
                  <template #button-content>
                    <b-icon
                      icon="three-dots"
                    />
                  </template>
                  <b-dropdown
                    v-show="data.item.content || data.item.media_url"
                    id="dropdown-2"
                    class="w-100"
                    toggle-class="text-left"
                    variant="none"
                    left
                    no-caret
                    dropright
                    menu-class="overflow-y-auto "
                  >
                    <template #button-content>
                      <div class="flex items-center text-primary w-100 gap-2">
                        <img
                          class="w-[20px]"
                          src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/send-2.svg"
                          alt="icon pause"
                          srcset=""
                        >
                        <span class="hover-salmon text-6 ">Kirim Ulang</span>
                        <b-icon
                          icon="chevron-right"
                          class="cursor-pointer"
                        />
                      </div>
                    </template>
                    <b-dropdown-form
                      v-show="data.item.content || data.item.media_url"
                      role="button"
                      class="w-[180px]"
                      @click="reSendMessage(data.item,'new')"
                    >
                      <div class="flex items-center gap-2">
                        <img
                          class="w-[20px]"
                          src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/message-add.svg"
                          alt=""
                        >
                        <span class="text-[#333333]">Penerima Baru</span>
                      </div>
                    </b-dropdown-form>
                    <b-dropdown-form
                      v-if="data.item.failed > 0 && (data.item.content || data.item.media_url)"
                      role="button"
                      class="w-[180px]"
                      @click="reSendMessage(data.item,'failed')"
                    >
                      <div class="flex items-center gap-2">
                        <img
                          class="w-[20px]"
                          src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/message-remove.svg"
                          alt=""
                        >
                        <span class="text-[#333333]">Penerima Gagal</span>
                      </div>
                    </b-dropdown-form>
                  </b-dropdown>
                  <b-dropdown-form
                    role="button"
                    class=""
                    @click="handleDetail(data.item.id)"
                  >
                    <div class="text-[#333333]">
                      Lihat Detail
                    </div>
                  </b-dropdown-form>
                  <b-dropdown-form
                    v-show="data.item.content || data.item.media_url"
                    role="button"
                    class=""
                    @click="viewPreview(data.item)"
                  >
                    <div class="text-[#333333]">
                      Preview
                    </div>
                  </b-dropdown-form>
                </b-dropdown>
              </div>
            </template>

            <!-- </b-dropdown> -->
          </BTable>
        </BOverlay>
      </b-col>
    </b-row>
    <ModalConfirmBroadcast
      :action="actionBroadcast"
      @onHandleConfirmBroadcast="handleConfirmBroadcast"
    />
    <ModalPreviewTemplate
      :id="`modal-preview-template-lite`"
      :template="templatePreview"
      :image="broadcastSend.image"
      :caption="broadcastSend.caption"
      :type-message="broadcastSend.type"
    />
    <ModalSendBroadcast
      :broadcast="broadcastSend"
      :list-failed-broadcast="failed.data"
      @nextGetListFailed="() => getListFailedContact(true)"
      @hidden="resetBroadcastSend"
      @close="resetBroadcastSend"
      @refresh="getDataBroadcast"
    />
  </div>
</template>
<script>
import {
  cardBroadcast, fieldsBroadcastTable, status, typeMessage,
} from '@/views/pages/komship/customer/Broadcast/config'
import {
  DDMMYYYY, TIME, LABELDAY, LABELMONTH, DAY_MONTH_YEAR, YYYYMMDD,
} from '@/libs/formatDate'
import DateRangePicker from 'vue2-daterange-picker'
import {
  firstDateOfMonth,
  lastDateOfLastMonth,
  lastMonth,
  today, last7, last30, last2,
} from '@/store/helpers'
import {
  apiGetBroadcast, apiActionBroadcast, apiGetBroadcastLiteInfo, apiGetListFailedContact,
} from '../service/api.broadcast.service'
import ModalConfirmBroadcast from './ModalConfirmBroadcast.vue'
import ModalPreviewTemplate from './ModalPreviewTemplate.vue'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import ModalSendBroadcast from './ModalSendBroadcast.vue'

export default {
  components: {
    ModalConfirmBroadcast,
    ModalPreviewTemplate,
    DateRangePicker,
    ModalSendBroadcast,
  },
  data() {
    return {
      cardBroadcast,
      fieldsBroadcastTable,
      status,
      typeMessage,
      whatsAppList: this.$store.state.komchat.whatsAppList,
      items: [],
      actionBroadcast: '',
      idBroadcast: '',
      isLoading: false,
      DDMMYYYY,
      YYYYMMDD,
      TIME,
      LABELDAY,
      LABELMONTH,
      DAY_MONTH_YEAR,
      templatePreview: '',
      isDropdown2Visible: false,
      broadcast: {
        cursor: '',
        limit: 10,
        start_date: '',
        end_date: '',
        search: '',
        loading: false,
        lastData: false,
        debounce: 0,
        broadcast_type: [],
        broadcast_status: [],
      },
      filterDebounce: null,
      infoLoading: false,
      failed: {
        cursor: '',
        limit: 10,
        loading: false,
        lastData: false,
        data: [],
      },
      filter: {
        dateRange: {
          startDate: firstDateOfMonth,
          endDate: today,
        },
      },
      broadcastSend: {
        title: '',
        newTitle: '',
        content: [],
        type: '',
        failed: '',
        id: '',
        image: '',
        caption: '',
        date: '',
        time: '',
        broadcast_mode: '',
        schedule: '',
      },
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
      ranges: {
        'Hari ini': [today, today],
        Kemarin: [last2, last2],
        '7 Hari Terakhir': [last7, today],
        '30 Hari Terakhir': [last30, today],
        'Bulan ini': [firstDateOfMonth, today],
        'Bulan lalu': [lastMonth, lastDateOfLastMonth],

      },
      broadcastInfo: [],
    }
  },
  watch: {
    'filter.dateRange': {
      handler() {
        this.handleFilter()
      },
      deep: true,
    },
  },
  mounted() {
    this.getDataBroadcast()
    this.getBroadcastInfo()
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = true
      }
      if (bvEvent.componentId === 'dropdown-3') {
        this.isDropdown2Visible = true
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = false
      }
      if (bvEvent.componentId === 'dropdown-3') {
        this.isDropdown2Visible = false
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault()
      }
    })
  },
  methods: {
    defineBroadcastTypeCard(type) {
      const broadcast = {
        broadcast: 'Broadcast',
        text: 'Pesan Teks',
        media: 'Pesan Media',
        text_media: 'Pesan Teks & Media',
      }
      return broadcast[type]
    },
    defineBroadcastType(type) {
      const broadcast = {
        TEXT: 'Text',
        MEDIA: 'Media',
        TEXT_MEDIA: 'Text & Media',
      }
      return broadcast[type]
    },
    handleFilter() {
      // Clear any pending filter debounce
      if (this.filterDebounce) {
        clearTimeout(this.filterDebounce)
      }

      this.filterDebounce = setTimeout(() => {
        this.fetchBroadcast(true)
        this.getBroadcastInfo()
      }, 300)
    },
    async fetchBroadcast(reset = false) {
      // Skip if we're loading next page but already at the end
      if (!reset && this.broadcast.lastData) {
        return
      }

      // If reset (filter), cancel any pending scroll requests by just proceeding
      // If not reset (scroll), skip if already loading
      if (!reset && this.broadcast.loading) {
        return
      }

      this.broadcast.loading = true

      // Reset cursor when fetching initial data
      if (reset) {
        this.broadcast.cursor = ''
      }

      try {
        const { data } = await apiGetBroadcast(this.broadcast.search, this.broadcast.cursor, this.broadcast.limit, this.broadcast.broadcast_type.join(','), this.broadcast.broadcast_status.join(','), YYYYMMDD(this.filter.dateRange.startDate), YYYYMMDD(this.filter.dateRange.endDate))
        const items = data.data

        // Replace or append items based on reset flag
        if (reset) {
          this.items = items
        } else {
          this.items.push(...items)
        }

        // Update cursor and lastData flag
        this.broadcast.cursor = data.meta.pagination.next_cursor_str
        this.broadcast.lastData = items.length < this.broadcast.limit || !this.broadcast.cursor

        this.broadcast.loading = false
      } catch (error) {
        console.error(error)
        this.broadcast.loading = false
        this.$toast_error({ message: this.capitalizeWords(error.response.data.meta.message) })
      }
    },
    viewPreview(data) {
      this.templatePreview = data.content
      this.broadcastSend.image = data.media_url
      this.broadcastSend.caption = data.media_caption
      this.broadcastSend.type = data.broadcast_type
      this.$bvModal.show('modal-preview-template-lite')
    },
    async getDataBroadcast() {
      await this.fetchBroadcast(true)
    },
    async getNextDataBroadcast() {
      await this.fetchBroadcast(false)
    },
    async reSendMessage(data, type) {
      const {
        content, id, title, failed, media_url, media_caption, broadcast_mode, schedule,
      } = data
      this.broadcastSend.id = id
      this.broadcastSend.type = type
      this.broadcastSend.content = content
      this.broadcastSend.title = title
      this.broadcastSend.newTitle = `${title} [Resend]`
      this.broadcastSend.failed = failed
      this.broadcastSend.image = media_url
      this.broadcastSend.caption = media_caption
      this.broadcastSend.broadcast_mode = broadcast_mode
      if (schedule) {
        const [date, time] = schedule.split(' ')
        this.broadcastSend.date = date
        this.broadcastSend.time = time
      }
      // Reset state untuk infinite scroll saat modal dibuka
      this.failed.cursor = ''
      this.failed.lastData = false
      this.failed.data = []
      if (failed) {
        await this.getListFailedContact(false)
      }
      this.$bvModal.show('modal-send-broadcast')
    },

    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        this.getNextDataBroadcast()
      }
    },
    resetBroadcastSend() {
      this.broadcastSend.title = ''
      this.broadcastSend.newTitle = ''
      this.broadcastSend.content = []
      this.broadcastSend.type = ''
      this.broadcastSend.failed = ''
      this.broadcastSend.id = ''
      this.broadcastSend.image = ''
      this.broadcastSend.caption = ''
      this.broadcastSend.date = ''
      this.broadcastSend.time = ''
      this.broadcastSend.broadcast_mode = ''
      this.broadcastSend.schedule = ''

      this.failed.cursor = ''
      this.failed.lastData = false
      this.failed.data = []
    },
    handleSearchReceiver() {
      clearTimeout(this.broadcast.debounce)

      // eslint-disable-next-line no-underscore-dangle
      this.broadcast.debounce = setTimeout(() => {
        this.getDataBroadcast()
      }, 2000)
    },
    async handleActionBroadcast(id, action) {
      this.idBroadcast = id
      this.actionBroadcast = action

      if (action === 'cancel' || action === 'delete') {
        this.$bvModal.show('modal-confirm-broadcast')
        return
      }
      const response = await this.$swal({
        title: `${this.capitalizeWords(action)} Broadcast`,
        html: `<span class="my-2">Apakah anda yakin ingin me-${action} broadcast ini?<span>`,
        confirmButtonText: `${this.capitalizeWords(action)}`,
        icon: 'question',
        width: 500,
        confirmButtonClass: 'btn btn-primary',
        showCancelButton: true,
        cancelButtonText: 'Batal',
        cancelButtonClass: 'btn btn-secondary',
        showLoaderOnConfirm: true,
        preConfirm: () => new Promise(resolve => {
          setTimeout(() => {
            resolve()
          }, 2000)
        }),
        allowOutsideClick: () => !this.$swal.isLoading(),
      })
      if (response.isConfirmed) {
        await this.handleConfirmBroadcast()
      }
    },
    async handleConfirmBroadcast() {
      this.broadcast.loading = true
      try {
        const param = {
          id: this.idBroadcast,
          action: this.actionBroadcast,
        }
        await apiActionBroadcast({ param })

        await this.getDataBroadcast()
        this.$bvModal.hide('modal-confirm-broadcast')
      } catch (error) {
        this.$toast_error({ message: this.capitalizeWords(error.response.data.meta.message) })
      } finally {
        this.broadcast.loading = false
      }
    },
    capitalizeWords(str) {
      if (!str) return str
      return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
    },
    async getBroadcastInfo() {
      // Skip if already loading for non-reset calls
      if (this.infoLoading) {
        return
      }

      this.infoLoading = true
      try {
        const { data } = await apiGetBroadcastLiteInfo(this.broadcast.broadcast_type.join(','), this.broadcast.broadcast_status.join(','), YYYYMMDD(this.filter.dateRange.startDate), YYYYMMDD(this.filter.dateRange.endDate))

        this.broadcastInfo = data.data
      } catch (error) {
        this.$toast_error({ message: this.capitalizeWords(error.response.data.meta.message) })
      } finally {
        this.infoLoading = false
      }
    },
    handleDetail(id) {
      this.$router.push(`/broadcast/history-lite/${id}`)
    },
    async getListFailedContact(isNextPage = false) {
      // Jika ini next page dan sudah lastData, return
      if (isNextPage && this.failed.lastData) {
        return
      }

      // Jika sedang loading, hindari double request
      if (this.failed.loading) {
        return
      }

      // Reset state jika bukan next page
      if (!isNextPage) {
        this.failed.cursor = ''
        this.failed.lastData = false
      }

      this.failed.loading = true
      try {
        const { data } = await apiGetListFailedContact(
          this.broadcastSend.id,
          this.failed.cursor,
          this.failed.limit,
        )
        const listContactFailed = data.data
        this.failed.cursor = data.meta.pagination.next_cursor_str

        if (listContactFailed.length < this.failed.limit || listContactFailed.length === 0 || !this.failed.cursor) {
          this.failed.lastData = true
        } else {
          this.failed.lastData = false
        }

        if (isNextPage) {
          this.failed.data.push(...listContactFailed)
        } else {
          this.failed.data = listContactFailed || []
        }
      } catch (error) {
        this.$toast_error({ message: error.response.data.meta.message })
        if (!isNextPage) {
          this.failed.data = []
        }
      } finally {
        this.failed.loading = false
      }
    },
  },
}
</script>
